import React from "react";
import { FaMapMarkerAlt, FaLongArrowAltRight, FaPhone } from "react-icons/fa";
import { AiFillInstagram, AiFillLinkedin } from "react-icons/ai";

import { Heading } from "src/components/global/Heading";
import AustralianMadeLogo from "src/assets/australian-made.svg";
import AustralianStandardsLogo from "src/assets/standards-australia-logo.png";
import { ContactForm } from "src/components/global/ContactForm";

export const Footer = () => {
  return (
    <>
      <footer className="bg-black pt-16 relative">
        <div className="container mx-auto max-w-7xl">
          <section className="grid grid-cols-12 relative pb-20 mx-16 lg:mx-0 lg:pb-24">
            <div className="col-span-12 flex flex-row items-center relative">
              <h3 className="text-white text-2xl lg:text-4xl uppercase font-bold flex flex-row items-center">
                Need more info? Get in touch today
                <FaLongArrowAltRight className="text-white text-5xl ml-24 rotate-90 lg:rotate-0" />
              </h3>
              <div className="white-line h-0.5 bg-white w-full absolute lg:-left-40 top-32 lg:top-28" />
            </div>
            <div className="mt-16 md:mt-28 col-span-12 lg:col-span-3 flex flex-col">
              {" "}
              <div className="socials flex flex-row items-center">
                <a
                  className="text-sm mt-2 transition-all duration-350"
                  href="https://www.linkedin.com/company/empirewelding"
                  target="_blank"
                >
                  <AiFillLinkedin className="text-white text-[35px] mb-3 transition-all duration-350 hover:text-orange" />
                </a>
                <a
                  className="text-sm mt-2 transition-all duration-350"
                  href="https://goo.gl/maps/TyU26TRKpJsYymBX6"
                  target="_blank"
                >
                  <AiFillInstagram className="text-white text-[35px] mb-3 transition-all duration-350 hover:text-orange" />
                </a>
              </div>
              <div className="group location mt-8 text-white z-50 flex flex-col">
                <a
                  className="text-sm mt-2 transition-all duration-350 group-hover:text-orange"
                  href="https://goo.gl/maps/TyU26TRKpJsYymBX6"
                  target="_blank"
                >
                  <FaMapMarkerAlt className="text-white text-4xl mb-3 transition-all duration-350  group-hover:text-orange" />
                  <h4 className="text-white text-lg font-bold uppercase transition-all duration-350 group-hover:text-orange">
                    Our location
                  </h4>
                  20-22 Marriot Street,
                  <br /> Cannington WA 6107
                </a>
              </div>
              <div className="contact mt-16 text-white z-50 flex flex-col">
                <FaPhone className="text-white text-4xl mb-3" />
                <h4 className="text-white text-lg font-bold uppercase">
                  Get in Touch
                </h4>
                <a
                  className="text-sm transition-all duration-350 hover:text-orange"
                  href="tel:0418 902 461"
                >
                  0418 902 461
                </a>
              </div>
            </div>
            <div className="mt-16 lg:mt-28 col-span-12 lg:col-span-4 flex flex-col">
              <Heading
                level="h2"
                className="text-white uppercase leading-tight"
              >
                Perth Welding & Fabrication Specialists
              </Heading>
              <p className="text-white text-md mt-8">
                Let Empire Welding be your one stop fabrication shop that’s
                willing to listen to your needs and provide practical options
                around build and delivery of your works which is tailored with
                easy access to the people coordinating your jobs.
              </p>
              <div className="logos flex flex-col md:flex-row items-center">
              <a href="https://australianmade.com.au/" target="_blank">
                <img
                  src={AustralianMadeLogo}
                  className="w-20 mt-8 transition-all duration-350 hover:scale-110"
                />
              </a>
              <a href="https://www.standards.org.au/" target="_blank">
                <img
                  src={AustralianStandardsLogo}
                  className="w-32 mt-8 transition-all duration-350 hover:scale-110 lg:ml-8"
                />
              </a>
              </div>
             
            </div>
            <div className="white-line h-0.5 bg-white w-full absolute lg:-left-40 bottom-12 lg:bottom-0" />
          </section>
          <section
            id="copyright-footer"
            className="grid grid-cols-12 mx-8 lg:mx-0 relative lg:py-8 text-center lg:text-start"
          >
            <div className="hidden lg:block lg:col-span-3"></div>
            <div className="mb-8 lg:mb-0 col-span-12 lg:col-span-6">
              <span className="text-white text-md">
                © Copyright Empire Welding 2024 | Website crafted by{" "}
                <a
                  href="https://www.limitlessdevs.com.au"
                  target="_blank"
                  className="text-white text-md transition-all duration-350 hover:text-orange"
                >
                  Limitless Devs
                </a>
              </span>
            </div>
          </section>
        </div>
        <ContactForm />
      </footer>
    </>
  );
};
